import axios from 'axios';
import { getApiUrl } from '../../config/api';

export default class AddGrupouViewController {
  constructor() {
    this.grupou = {
      GrupouCode: '',
      GrupouName: '',
      EsActivo: true
    };
    this.saving = false;
    this.error = null;
  }

  // Inicializar el controlador
  initialize() {
    this.resetForm();
  }

  // Resetear formulario
  resetForm() {
    this.grupou = {
      GrupouCode: '',
      GrupouName: '',
      EsActivo: true
    };
    this.saving = false;
    this.error = null;
  }

  // Actualizar campo del formulario
  updateField(field, value) {
    this.grupou[field] = value;
  }

  // Validar formulario
  validateForm() {
    if (!this.grupou.GrupouCode || !this.grupou.GrupouCode.trim()) {
      return false;
    }
    return true;
  }

  // Guardar grupo
  async saveGrupou() {
    if (this.saving) {
      throw new Error('Ya se está guardando el grupo');
    }

    this.saving = true;
    this.error = null;

    try {
      const response = await axios.post(getApiUrl('/api/Grupou/guardar'), this.grupou);
      return response;
    } catch (error) {
      console.error('Error al guardar grupo:', error);
      this.error = 'Error al guardar el grupo. Por favor, intente de nuevo.';
      throw error;
    } finally {
      this.saving = false;
    }
  }

  // Getters para el estado
  getGrupou() {
    return this.grupou;
  }

  isSaving() {
    return this.saving;
  }

  getCurrentError() {
    return this.error;
  }
}